<template>
    <div class="chat container">
      <h5 class="grey-text text-darken-h4">Chat: {{name}}</h5>
      <div class="row" >
        <div class="col s12 m12 l10">
          <div class="card">
            <div class="card-content" >
              <ul class="messages" v-chat-scroll style="border-style: solid;border-width: 1px;">
                <li v-for="message in messages" :key="message.id">
                  <span class="grey-text time blue-grey lighten-4" >{{message.timestamp}}</span>
                  <span class="text name blue-grey lighten-2">{{message.name}}</span>
                  <span class="grey-text text-darken-h3 content">{{message.content}}</span>
                </li>
              </ul>
            </div>
        <div class="card action">
          <NewMessage :name="name"></NewMessage>
          <input type="text">
        </div>
          </div>
        </div>
      <div class="col s2 card" style="margin-left: -10px; height: 510px" ref="container">
     <ul>
          <li v-for="message in uniqueNames"   class="card user" >
            <span style="font-size: 0.7em; margin-left: 5px" @click="newchat" >{{message}}</span></li>
        </ul>
      </div>
    </div>
    </div>
</template>
<script>
  import NewMessage from "@/components/NewMessage"
  import db from '@/firebase/init'
  import moment from 'moment'
  import Vue from 'vue'
  import Button from '@/components/Button'
  import {setUser} from "../../firebase/GlobalDBFunctions"

    export default {
        name: "Chat",
        props: ['name'],
        components: {
            NewMessage,
            Button
        },
        data() {
            return {
              messages: [],
                arr : [],
                inputs:[],
                holder:name
            }
        },
        methods: {
            newchat: function(){
                var ComponentClass = Vue.extend(Button)
                var instance = new ComponentClass({
                    propsData: { type: 'primary' }
                })
                instance.$slots.default = ['Neuer Chat']
                instance.$mount()
                this.$refs.container.appendChild(instance.$el)
            }
        },
        computed: {
            uniqueNames: function() {
                let messagesnew = [];
                for(let i =0; i < this.messages.length; i++) {
                    if(messagesnew.indexOf(this.messages[i].name) === -1) {
                        messagesnew.push(this.messages[i].name)
                    }
                }
                return messagesnew;
            }
        },
            created() {
                let ref = db.collection('messages').orderBy('timestamp')
                ref.onSnapshot(snapshot => {
                    snapshot.docChanges().forEach(change => {
                        if (change.type == 'added') {
                            let doc = change.doc
                            this.messages.push({
                                id: doc.id,
                                name: doc.data().name,
                                content: doc.data().content,
                                timestamp: moment(doc.data().timestamp).format('lll')
                            })
                        }
                    })
                })

            },
        mounted() {
            setUser(this.name);
        }
    }
</script>

<style scoped>
    .chat h2{
      font-size: 2.6em;
      margin-bottom: 40px;
    }
  .chat span{
    font-size: 1.5em;
  }
  .chat .time{
    font-size: 0.9em;
  }
  .chat .name{
    text-align: right;
    width: 40px;
    font-size: 1.0em;
  }
  .chat .content{
    margin-left: 5px;
    font-size: 1.1em;
  }
  .messages {
    max-height: 300px;
    overflow: auto;
  }
  .messages::-webkit-scrollbar{
      width: 3px;
  }
  .messages::-webkit-scrollbar-track{
      background: #ddd;
  }
  .messages::-webkit-slider-thumb{
    background:#aaa;
  }
  .user{
    margin-top: -15px;
    margin-left: -10px;
    margin-right: -10px;
    width: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/Chat/Chat.vue